
import styled from "styled-components";
import AppBar from '@mui/material/AppBar';

export const CustomAppBar = styled(AppBar)`
  background-color: #fff !important;
  font-family: 'Noto Sans', sans-serif;
  color: #000000;

  .settingIcon{
    color: #1B4A83;
    margin-right: 20px;
  }
  .helpIcon{
    color: #1B4A83;
    margin-right: 20px;
  }
  .menuWeb{


                        @media screen and (min-device-width: 1098px) and (max-device-width: 1299px) { 
                                padding: 0px 0px 0px 5%;
                                gap: 18px;
     
    }
                            @media screen and (min-device-width: 900px) and (max-device-width: 1097px) { 
                                padding: 0px 0px 0px 5%;
                                gap: 8px;
     
    }
    }


`;
